import { SearchInput } from '@ardoq/forms';
import {
  ReferenceFilter,
  ReferenceFilterOptions,
  type ReferenceFilterLabels,
} from './ReferenceFilter';
import { EnhancedScopeData } from '@ardoq/data-model';
import { FlexBox } from '@ardoq/layout';

type ReferencesToolbarProps = {
  scopeData?: EnhancedScopeData;
  searchTerm: string;
  filters: ReferenceFilterOptions;
  setSearchTerm: (searchPhrase: string) => void;
  setFilters: (filters: ReferenceFilterOptions) => void;
  filterLabels?: ReferenceFilterLabels;
};

const ReferencesToolbar = ({
  scopeData,
  searchTerm,
  filters,
  setFilters,
  setSearchTerm,
  filterLabels,
}: ReferencesToolbarProps) => {
  if (!scopeData) return null;
  return (
    <FlexBox>
      <SearchInput
        onValueChange={setSearchTerm}
        value={searchTerm}
        dataTestId="reference-search-input"
      />
      <ReferenceFilter
        scopeData={scopeData}
        filters={filters}
        setFilters={setFilters}
        labels={filterLabels}
      />
    </FlexBox>
  );
};

export { ReferencesToolbar };
